/**
 * Helpers for large base64 PDFs. Data URLs are what break big files (browsers cap them and the
 * whole string has to live in the DOM), so the base64 is decoded into a Blob and served by an object URL.
 */

const CHUNK = 1024 * 1024 // base64 chars decoded per step (multiple of 4)

/** Removes any "data:...;base64," prefix, whitespace and quotes; converts URL-safe base64; fixes padding. */
export function cleanBase64 (input) {
  let b64 = String(input || '')
  const comma = b64.indexOf(',')
  if (b64.startsWith('data:') && comma > -1) b64 = b64.slice(comma + 1)
  b64 = b64.replace(/[\s"']/g, '').replace(/-/g, '+').replace(/_/g, '/')
  const rem = b64.length % 4
  if (rem === 1) throw new Error('Invalid base64 data')
  return rem ? b64 + '='.repeat(4 - rem) : b64
}

/** Decodes in chunks so a 100MB+ file never needs one giant binary string. */
export function base64ToBlob (input, type = 'application/pdf') {
  const b64 = cleanBase64(input)
  const parts = []
  for (let i = 0; i < b64.length; i += CHUNK) {
    const bin = atob(b64.slice(i, i + CHUNK))
    const bytes = new Uint8Array(bin.length)
    for (let j = 0; j < bin.length; j++) bytes[j] = bin.charCodeAt(j)
    parts.push(bytes)
  }
  return new Blob(parts, { type })
}

export function safeFileName (name, fallback = 'document') {
  const base = String(name || fallback).replace(/[\\/:*?"<>|]+/g, '_').trim() || fallback
  return /\.pdf$/i.test(base) ? base : base + '.pdf'
}
